import React from 'react';
import { GAP_TYPES } from '../../data/gapKeywords';

const OPTIONS = [
  { value: 'yes', label: '✓ Yes — confirmed', color: '#22c55e' },
  { value: 'unsure', label: '? Unsure', color: '#f59e0b' },
  { value: 'no', label: '✗ No — not present', color: '#ef4444' },
];

export default function Step4_GapConfirmation({ rankedGaps, confirmations, onChange, onNext, onBack }) {
  const update = (type, val) => onChange({ ...confirmations, [type]: val });

  const allReviewed = rankedGaps.length > 0 && rankedGaps.every((g) => confirmations[g.type]);

  return (
    <div className="gf-step">
      <div className="gf-step-header">
        <span className="gf-step-badge">Phase 4</span>
        <h2>Gap Type Confirmation</h2>
        <p>
          Review each detected gap type and confirm whether it reflects a genuine gap in your
          reviewed literature. Your responses adjust the final weighted rankings.
        </p>
      </div>

      <div className="gf-confirmation-list">
        {rankedGaps.map((gap, idx) => (
          <div key={gap.type} className="gf-confirm-card">
            <div className="gf-confirm-header" style={{ borderLeftColor: gap.color }}>
              <div>
                <span className="gf-rank-badge">#{idx + 1}</span>
                <strong>{gap.label}</strong>
                <span className="gf-score-tag">Score: {gap.totalScore} | {gap.articleCount} article(s)</span>
              </div>
              <p className="gf-gap-desc">{GAP_TYPES[gap.type]?.description}</p>
            </div>

            <div className="gf-confirm-question">
              <p>Do you confirm that a <strong>{gap.label.toLowerCase()}</strong> exists in your reviewed literature?</p>
              <div className="gf-confirm-options">
                {OPTIONS.map((opt) => (
                  <button
                    key={opt.value}
                    className={`gf-confirm-btn ${confirmations[gap.type] === opt.value ? 'selected' : ''}`}
                    style={confirmations[gap.type] === opt.value ? { background: opt.color, borderColor: opt.color, color: '#fff' } : {}}
                    onClick={() => update(gap.type, opt.value)}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Show matched keywords for this gap */}
            {gap.topKeywords && gap.topKeywords.length > 0 && (
              <div className="gf-matched-kws">
                <strong>Detected signals:</strong>
                {gap.topKeywords.map((kw, i) => (
                  <span key={i} className="gf-kw-tag">{kw}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {!allReviewed && (
        <p className="gf-hint gf-warn">Please respond to all gap types before proceeding.</p>
      )}

      <div className="gf-nav">
        <button className="gf-btn gf-btn-secondary" onClick={onBack}>← Back</button>
        <button className="gf-btn gf-btn-primary" onClick={onNext} disabled={!allReviewed}>
          Validate Gap →
        </button>
      </div>
    </div>
  );
}
